import { render } from "./dropdown.vue?vue&type=template&id=96cfd7be&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=96cfd7be&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96cfd7be"]])

export default __exports__